import { MutableRefObject, useCallback } from 'react';
import { runOnJS, useAnimatedReaction, useSharedValue } from 'react-native-reanimated';

import { AutoScrollingListRef } from '@/feature/fantasy-event-sheets/components/AutoScrollingList';

import { useFantasyFullScreenPagerTransition } from '../FantasyFullScreenPagerTransitionProvider';

/**
 * Hook used to start the auto scroll of the AutoScrollingList, right after the mount animation has started.
 * @param autoScrollingList - ref to the AutoScrollingList
 */
export const useStartAutoScroll = (
    autoScrollingListRef: MutableRefObject<AutoScrollingListRef | null>,
    enabled: boolean = false
) => {
    const { sheetMountAnimationProgress } = useFantasyFullScreenPagerTransition();

    const hasStartedAutoScroll = useSharedValue(false);

    const startAutoScroll = useCallback(() => {
        autoScrollingListRef.current?.start();
    }, [autoScrollingListRef]);

    useAnimatedReaction(
        () => sheetMountAnimationProgress.value,
        currentValue => {
            // start the auto scroll immediately after the mount animation has started
            if (enabled && currentValue > -0.9 && !hasStartedAutoScroll.value) {
                runOnJS(startAutoScroll)();
                hasStartedAutoScroll.value = true;
            }
        }
    );
};
